// serviceWorkerRegistration.ts
// CRA-style service worker registration

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then()
        .catch(error => {
          console.error('ServiceWorker registration failed: ', error);
        });
    });
  }
}
